import { optOutOptions } from '@/globalConsts';

// get the label for the opt-out reason, if it exists in the optOutOptions array, otherwise return the original value
export const formatOptOutReason = (opt_out_reason: string) => {
	const optOutOption = optOutOptions.find((option) => option.value === opt_out_reason);
	return optOutOption ? optOutOption.label : opt_out_reason;
};
